import React from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import TextActionAccordion from '../TextActionAccordion';
import { ActionState } from '../ActionStateBannerStyleDownloadButton';

import { TREATMENT_DOWNLOAD_BUTTON_TYPES } from '../../app/constants/treatment';

import styles from './index.module.scss';

export interface ButtonData {
  type?: string;
  label: string;
  text?: string;
  imageUrl?: string;
  imageAlt?: string;
  fileName: string;
  state?: ActionState;
  onClick: () => void;
  error?: boolean;
  className: string;
}

export interface BannerStyleDownloadButtonActionAccordionProps {
  activeStateTagText?: string;
  number: string;
  title: string;
  subtitle?: string;
  text?: string;
  isOpenByDefault?: boolean;
  leftButtonText?: string;
  buttonOnClick?: () => void;
  isButtonLoading?: boolean;
  leftButtonError?: object;
  completed: boolean;
  rightButtonText?: string;
  rightButtonUrl?: string;
  contentLinkText?: string;
  contentLinkUrl?: string;
  nutritionDownloadButtonError?: boolean;
  nutritionDownloadButtonData?: any;
  className?: string;
  children?: React.ReactNode;
}

const BannerStyleDownloadButtonActionAccordion: React.FC<
  BannerStyleDownloadButtonActionAccordionProps
> = ({
  activeStateTagText,
  number,
  title,
  subtitle,
  text,
  isOpenByDefault,
  leftButtonText,
  buttonOnClick,
  isButtonLoading,
  leftButtonError,
  completed,
  rightButtonText,
  rightButtonUrl,
  contentLinkText,
  contentLinkUrl,
  className,
  children,
  nutritionDownloadButtonData,
  nutritionDownloadButtonError,
}) => {
  return (
    <div className={cx(styles.wrapper, className)}>
      <TextActionAccordion
        title={title}
        subtitle={subtitle}
        isOpenByDefault={isOpenByDefault}
        text={text}
        number={number}
        activeStateTagText={activeStateTagText}
        leftButtonText={leftButtonText}
        buttonOnClick={buttonOnClick}
        isButtonLoading={isButtonLoading}
        leftButtonError={leftButtonError}
        completed={completed}
        rightButtonText={rightButtonText}
        rightButtonUrl={rightButtonUrl}
        contentLinkText={contentLinkText}
        contentLinkUrl={contentLinkUrl}
      >
        {/* TODO: Revisit this mapping */}
        {React.Children.map(children, (child, index) => (
          <div
            key={
              React.isValidElement(child) && child.key != null
                ? child.key
                : index
            }
            className={cx(styles.bannerStyleButton, {
              [styles.error]:
                nutritionDownloadButtonError &&
                nutritionDownloadButtonData.buttonType ===
                  TREATMENT_DOWNLOAD_BUTTON_TYPES.DOWNLOAD_ACTION_PLAN,
            })}
          >
            {child}
          </div>
        ))}
      </TextActionAccordion>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  nutritionDownloadButtonData: state.treatmentPage.get(
    'downloadNutritionAdviceActionPlanData',
  ),
  nutritionDownloadButtonError: state.treatmentPage.get(
    'downloadNutritionAdviceActionPlanError',
  ),
});

export default connect(mapStateToProps)(
  BannerStyleDownloadButtonActionAccordion,
);
